import request from '@/request'

const Service = {
  state: {
    pdfComplete: []
  },
  mutations: {
    GET_PDF_COMPLETE (state, data) {
      state.pdfComplete = data
    }
  },
  actions: {
    async uploadDocument({ commit },payload) {
      let response = { code: 'init', massage: null }
      await request({
        method: "POST",
        url: process.env.VUE_APP_API_UPLOAD_DOCUMENT,
        data: payload
      }).then((res) => {
        // console.log("response", res);
        response = res
        commit('GET_PDF_COMPLETE', res.responseData)
      }).catch(error => {
        console.error('res error >>>', error, error.response)
        response.code = error.response.status
        response.massage = error.response.statusText
      })
      return response
    }
  },
  getters: {
    pdfCompleteData(state) {
      return state.pdfComplete
    }
  }
}
export default Service